import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { TranslateModule } from '@ngx-translate/core';
import { ModalComponent } from '../../../utils/modal/modal.component';

@Component({
  selector: 'app-confirm-delete-user-modal',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, ModalComponent],
  templateUrl: './confirm-delete-user-modal.component.html',
})
export class ConfirmDeleteUserModalComponent {
  /** Set by modal service from data when opening. */
  userName = '';
  /** Set by modal service from data when opening. */
  titleKey = 'ADMIN.USERS.DELETE_CONFIRM_TITLE';
  /** Set by modal service from data when opening. */
  messageKey = 'ADMIN.USERS.DELETE_CONFIRM_MESSAGE';
  /** Set by modal service from data when opening. */
  submitTextKey = 'DELETE';
  /** Set by modal service from data when opening. */
  showOwnedMailAccountsWarning = false;
  /** Set by modal service from data when opening. */
  ownedMailAccounts: Array<{ id: number; name: string | null }> = [];

  constructor(public modalRef: MdbModalRef<ConfirmDeleteUserModalComponent>) {}
}
